import { DiseaseTypes, ProtectionTypes } from '@/common/variables';

export const isChecked = (val) => val === true;

export const isRequired = (val) => !!val;

export const diseaseTextByType = (type, disease) => {
  switch (type) {
    case DiseaseTypes.cancer: {
      const squamousText = disease.isSquamousCell
        ? '- Squamous or Basil cell'
        : '';
      return `Cancer ${squamousText}`;
    }

    case DiseaseTypes.heartAttack:
      return `Heart Attack - Blood thinners: ${disease.bloodThinner} 
          - Treated Timeframe: ${disease.treatedTimeframe}`;

    case DiseaseTypes.heartDisease:
      return `Heart Disease - Blood thinners: ${disease.bloodThinner} 
          - Treated Timeframe: ${disease.treatedTimeframe}`;

    case DiseaseTypes.stroke: {
      const tiaText = disease.tia ? '- TIA ' : '';
      const paralysisText = disease.paralysis ? '- Paralysis ' : '';

      return `Stroke ${tiaText} ${paralysisText}`;
    }

    case DiseaseTypes.diabetes: {
      const complicationsText = disease.complications ? '- Complications' : '';

      return `Diabetes - ${disease.treatmentType} - ${disease.a1c} ${complicationsText}`;
    }

    case DiseaseTypes.asthma:
      return `Asthma ${disease.hospitalizations ? '- Hospitalizations' : ''}`;

    case DiseaseTypes.sleepApnea:
      return `Sleep Apnea ${
        disease.hospitalizations ? '- Hospitalizations' : ''
      }`;

    case DiseaseTypes.copd:
      return `COPD ${disease.oxygenPrescribed ? '- Prescribed oxygen' : ''}`;

    case DiseaseTypes.emphysema:
      return `Emphysema ${
        disease.oxygenPrescribed ? '- Prescribed oxygen' : ''
      }`;

    case DiseaseTypes.depression:
      return `Depression ${
        disease.hospitalizations ? '- Hospitalizations' : ''
      }`;

    case DiseaseTypes.bloodPressure:
      return `Blood pressure ${
        disease.medsCount ? `- Meds: ${disease.medsCount}` : ''
      }`;

    case DiseaseTypes.cholesterol:
      return `Cholesterol ${
        disease.medsCount ? `- Meds: ${disease.medsCount}` : ''
      }`;

    case DiseaseTypes.chronicPain:
      return `Chronic Pain ${
        disease.hospitalizations ? '- Hospitalizations' : ''
      }`;

    default:
      return '';
  }
};

export const needTextByType = (type, need) => {
  switch (type) {
    case ProtectionTypes.debt:
      return `${need.label} - ${need.amount}`;

    case ProtectionTypes.mortgage:
      return `${need.label} - ${need.amount} - ${need.yearsLeft} years`;

    case ProtectionTypes.finalExpenses:
      return `${need.label} - ${need.target} - ${need.amount} minimum`;

    case ProtectionTypes.family: {
      const anyChildrenText = need.isAnyChildren
        ? `- ${need.childrenCount} children - ${need.childrenAge} years -
              ${need.collegeExpenses ? 'Need ' : "Don't"} college expenses`
        : '';

      return `${need.label} - ${need.isReplaceIncome ? 'Need' : "Don't"}
           income replacement ${anyChildrenText}`;
    }

    default:
      return '';
  }
};

